import { createContext } from "react";

const plataformasContext = createContext();

export default plataformasContext;
